module.exports = __webpack_public_path__ + "static/media/1717128339440-min.cad026be.JPG";